import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './LanguageForm.jsx'

export default createSubmit(name)